export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const SET_ACCESS_TOKEN_PROMISE = "SET_ACCESS_TOKEN_PROMISE";
